import type { AutoCompleteResult } from '@awaze/design-system.components.autocomplete'

import type { PlacesSuggestions } from './SearchForm.types'

export type TmsUpdateDataLayer = (
  type: string,
  event: string,
  data?: Record<string, unknown>,
) => void

type OriginalAutoSuggestSearch = (
  searchTerm: string,
  accommodationType: string,
  propertiesOnly: boolean,
) => Promise<AutoCompleteResult[]>

export const combineAutoSuggestSearch = (
  getSuggestions: PlacesSuggestions,
  originalAutoSuggestSearch: OriginalAutoSuggestSearch,
  tmsUpdateDataLayer?: TmsUpdateDataLayer,
): ((
  searchTerm: string | null,
  accommodationType?: string,
) => Promise<AutoCompleteResult[]>) => {
  return async (
    searchTerm: string | null,
    accommodationType?: string,
  ): Promise<AutoCompleteResult[]> => {
    if (!searchTerm) {
      return []
    }

    // Skip Places lookup entirely for boat-holidays — only use location lookup
    const forceLocationLookupIfBoats = accommodationType === 'boat-holidays'

    if (forceLocationLookupIfBoats) {
      return originalAutoSuggestSearch(searchTerm, accommodationType, false)
    }

    const [placesResult, originalResult] = await Promise.all([
      getSuggestions(searchTerm),

      originalAutoSuggestSearch(searchTerm, accommodationType as string, true),
    ])

    if (
      placesResult?.[0]?.type === 'GooglePlacesApiAutocomplete' ||
      placesResult.length === 0
    ) {
      tmsUpdateDataLayer?.('link', 'search-no destination result', {
        search_term: searchTerm,
      })
    }

    return [...placesResult, ...originalResult.filter((r) => r.property)]
  }
}
